import {useEffect, useState} from "react";
import {StyleProvider} from '@ant-design/cssinjs';
import DeviceContext from "@/Components/DeviceContext";
import { usePage } from "@inertiajs/react";

export default function ({children, isMobileView}: {
    children: React.ReactNode,
    isMobileView?: boolean,
}) {
    const [isMobile, setIsMobile] = useState(isMobileView || false)

    useEffect(() => {
        if (import.meta.env.SSR) {
            return
        }

        const onResize = () => {
            if (getWidth() < 768) {
                setIsMobile(true)
            }else{
                setIsMobile(false)
                const html = document.getElementsByTagName("html")[0];
                html.style.fontSize = '';
            }
        }
        window.addEventListener('resize', onResize)
        onResize()
        return () => {
            window.removeEventListener('resize', onResize)
        }
    }, [])

    useEffect(() => {
        const div = document.querySelector('#mobile-loading-mask')
        if (!div) {
            return
        }
        setTimeout(() => {
            div.remove()
        }, 1000)
        setTimeout(() => {
            div.classList.add('hidden')
        }, 300)

    }, []);

    const getWidth = () => {
        return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth
    }

    return <>
        <DeviceContext.Provider value={{
            isMobile: isMobile,
        }}>
            <StyleProvider hashPriority="high">
                <div className={isMobile ? 'device-mobile' : 'device-default'}>
                    {children}
                </div>
            </StyleProvider>
        </DeviceContext.Provider>
    </>
}